module.exports = __webpack_public_path__ + "img/personal.3c22a2a3.jpg";